import { IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";

interface ReportsTableActionMenuProps {
  handleOpenView: () => void;
  handleOpenDeleteDialog: () => void;
}

export default function ReportsTableActionMenu({
  handleOpenView,
  handleOpenDeleteDialog,
}: ReportsTableActionMenuProps) {
  return (
    <>
      <Tooltip title="Detalles">
        <IconButton aria-label="view" color="primary" onClick={handleOpenView}>
          <VisibilityIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Eliminar">
        <IconButton
          aria-label="delete"
          color="error"
          onClick={handleOpenDeleteDialog}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </>
  );
}
